import { render } from "./ColliPositionForm.vue?vue&type=template&id=9d02c62c"
import script from "./ColliPositionForm.vue?vue&type=script&lang=js"
export * from "./ColliPositionForm.vue?vue&type=script&lang=js"

import "./ColliPositionForm.vue?vue&type=style&index=0&id=9d02c62c&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__